import { render, staticRenderFns } from "./DialogPassword.vue?vue&type=template&id=07be5b59&scoped=true&"
import script from "./DialogPassword.vue?vue&type=script&lang=js&"
export * from "./DialogPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07be5b59",
  null
  
)

export default component.exports